import { colors } from '@material-ui/core';

const white = '#FFFFFF';
// const BekoMavi = '#007DBA';
const siyah = '#1D3343';

export default {
  primary: {
    contrastText: '#FFFFFF',
    dark: siyah,
    main: siyah,
    light: siyah
  },
  secondary: {
    contrastText: '#FFFFFF',
    dark: siyah,
    main: siyah,
    light: siyah
  },
  error: {
    contrastText: white,
    dark: colors.red[900],
    main: colors.red[600],
    light: colors.red[400]
  },
  text: {
    primary: colors.blueGrey[900],
    secondary: colors.blueGrey[600],
    link: colors.blue[600]
  },
  link: siyah,
  icon: siyah,
  background: {
    default: '#F4F6F8',
    paper: white
  },
  primaryOld: {
    light: '#757ce8',
    main: '#3f50b5',
    dark: '#002884',
    contrastText: '#fff'
  },
  secondaryOld: {
    light: '#ff7961',
    main: '#f44336',
    dark: '#ba000d',
    contrastText: '#000'
  },
  divider: colors.grey[200]
};
